import { motion } from "framer-motion";
import { TechnicalCardStyled } from "./TechnicalAnalisisCardStyles";
import { TechnicalCardInterface } from "../../../interfaces/TechnicalAnalisisCardInterface";
import { ForwardedRef, forwardRef } from "react";

export const TechnicalAnalisisCard = forwardRef(
  (
    { title, text }: TechnicalCardInterface,
    ref: ForwardedRef<HTMLDivElement>
  ) => {
    return (
      <TechnicalCardStyled ref={ref}>
        <h4>{title}</h4>
        <span></span>
        <p>{text}</p>
      </TechnicalCardStyled>
    );
  }
);

export const MTechnicalAnalisisCard = motion.create(TechnicalAnalisisCard);
